import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import "../../styles/ibutton/ibutton.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from "../../utils/dateConvert";

class DetailsIbutton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      serialNo: "",
      name: "",
      statee: "",
      lastevent: "",
      assetName: "",
      deviceName: "",
      lastDisconnect: "",
      tag1: "",
      tag2: "",
      description: "",
      profiles: [],
      profileId: "",
      profileName: "",
      color: "",
      icon: "",
      notes: "",
      adminNotes: "",
      status: [],
      statusId: "",
      statusName: "",
      id: "",
      created: "",
      updated: "",
      name_error: false,
    };
  }

  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/IButton/SelectIButton/${this.props.match.params.id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setData(response.data[0]);
      if (response.status == "200") {
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  setData = (data) => {
    const {
      name,
      tag1,
      tag2,
      lastDisconnect,
      notes,
      profile,
      state,
      deviceName,
      lastConnect,
      assetName,
      lastevent,
      status,
      serialNo,
      icon,
      description,
      customerName,
      colour,
      adminNotes,
      id,
      dbCreated,
      dbUpdated,
    } = data;
    this.setState({
      name,
      tag1,
      tag2,
      lastDisconnect,
      description,
      color: colour,
      assetName,
      lastConnect,
      deviceName,
      icon,
      lastevent,
      notes,
      statee: state,
      serialNo,
      adminNotes,
      customerName,
      profileName: profile,
      statusName: status,
      id,
      created: dbCreated,
      updated: dbUpdated,
    });
  };

  handleOk = () => {
    this.props.history.push("/ibutton");
  };

  handleNameChange = (e) => {
    this.setState({
      name: e.target.value,
      name_error: e.target.value == "",
    });
  };

  handleSave = async () => {
    if (this.state.name == "") {
      this.setState({ name_error: true });
      return;
    }

    this.props.setLoadingPageAction(true);
    try {
      await axios.post(
        `${apiHost}/api/IButton/IButtonUpdate`,
        {
          id: this.state.id,
          name: this.state.name,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.props.setLoadingPageAction(false);
      this.props.history.push("/ibutton");
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  };

  normalizeConnectionState = (state) => {
    const normalizedState = (state || "").toString().toLowerCase();

    if (normalizedState === "connected") {
      return "connected";
    }

    if (normalizedState === "disconnected") {
      return "disconnected";
    }

    return "unknown";
  };

  normalizeStatus = (status) => {
    const normalizedStatus = (status || "").toString().toLowerCase();

    if (normalizedStatus === "disabled" || normalizedStatus === "disable" || normalizedStatus === "0") {
      return "disabled";
    }

    if (normalizedStatus === "active" || normalizedStatus === "enabled" || normalizedStatus === "1") {
      return "active";
    }

    return "unknown";
  };

  renderField = (label, value) => (
    <div className="ibutton-detail-field">
      <span>{label}</span>
      <strong>{value || "-"}</strong>
    </div>
  );

  renderNameField = () => (
    <div className="ibutton-detail-field ibutton-detail-edit-field">
      <div className="ibutton-edit-label-row">
        <span>Friendly Name</span>
        <em>Editable</em>
      </div>
      <Form.Control
        type="text"
        value={this.state.name}
        onChange={this.handleNameChange}
      />
      <p
        className={
          this.state.name_error
            ? "ibutton-detail-error"
            : "ibutton-detail-error hidden"
        }
      >
        The Name field is required.
      </p>
    </div>
  );

  render() {
    const {
      name,
      statee,
      deviceName,
      lastDisconnect,
      lastConnect,
      assetName,
      lastevent,
      serialNo,
      statusName,
      customerName,
      created,
      updated,
    } = this.state;
    const connectionState = this.normalizeConnectionState(statee);
    const statusState = this.normalizeStatus(statusName);

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Edit iButton </title>
          </Helmet>
          <div className="contentBody ibutton-page-shell">
            <div className="contentWrapper ibutton-detail-page">
              <div className="ibutton-detail-header">
                <div>
                  <span className="ibutton-detail-kicker">Edit iButton</span>
                  <h2>{name || "iButton"}</h2>
                  <div className="ibutton-detail-subtitle">
                    <span>{serialNo || "No serial"}</span>
                    <span className={`ibutton-connection ibutton-connection-${connectionState}`}>
                      {statee || "-"}
                    </span>
                    <span className={`ibutton-status ibutton-status-${statusState}`}>
                      {statusName || "-"}
                    </span>
                  </div>
                  <p>Apply a friendly name for this iButton. All other fields are read-only.</p>
                </div>

                <div className="ibutton-detail-header-actions">
                  <Button variant="light" onClick={this.handleOk}>
                    Back to List
                  </Button>
                  <Button variant="primary" onClick={this.handleSave}>
                    Save Changes
                  </Button>
                </div>
              </div>

              <section className="ibutton-detail-tile">
                <div className="ibutton-detail-section-title">
                  <h3>Identity</h3>
                  <p>Customer and serial are fixed; friendly name can be updated.</p>
                </div>

                <div className="ibutton-detail-grid">
                  {this.renderField("Customer", customerName)}
                  {this.renderField("Serial No", serialNo)}
                  {this.renderNameField()}
                </div>
              </section>

              <section className="ibutton-detail-tile">
                <div className="ibutton-detail-section-title">
                  <h3>Assignment</h3>
                  <p>Current linked asset and device information.</p>
                </div>

                <div className="ibutton-detail-grid">
                  {this.renderField("Asset", assetName)}
                  {this.renderField("Device", deviceName)}
                  {this.renderField("Last Event", utcToLocal(lastevent))}
                </div>
              </section>

              <section className="ibutton-detail-tile">
                <div className="ibutton-detail-section-title">
                  <h3>Connection</h3>
                  <p>Connection status and recent activity timestamps.</p>
                </div>

                <div className="ibutton-detail-grid">
                  {this.renderField("State", statee)}
                  {this.renderField("Status", statusName)}
                  {this.renderField("Last Connected", utcToLocal(lastConnect))}
                  {this.renderField("Last Disconnected", utcToLocal(lastDisconnect))}
                </div>
              </section>

              <div className="ibutton-detail-meta">
                <div>
                  <span>Created</span>
                  <strong>{utcToLocal(created)}</strong>
                </div>
                <div>
                  <span>Updated</span>
                  <strong>{utcToLocal(updated)}</strong>
                </div>
              </div>

              <div className="ibutton-detail-footer">
                <Button variant="outline-secondary" onClick={this.handleOk}>
                  Back to List
                </Button>
                <Button variant="primary" onClick={this.handleSave}>
                  Save Changes
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsIbutton);
